import { actionTypes as topUpActions } from './topUp.actions';

const initialState = {
    isTopUpModalVisible: false,
    cardDetails: null,
    isCardDetailsError: false,
    topUpErrorInfo: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case topUpActions.SHOW_TOP_UP_MODAL:
            return {
                ...state,
                isTopUpModalVisible: true,
            };
        case topUpActions.CARD_DETAILS_RECEIVED:
            return {
                ...state,
                cardDetails: action.cardDetails,
                isCardDetailsError: false,
            };
        case topUpActions.CARD_DETAILS_ERROR:
            return {
                ...state,
                isCardDetailsError: true,
            };
        case topUpActions.HIDE_TOP_UP_MODAL:
            return {
                ...state,
                isTopUpModalVisible: false,
                topUpErrorInfo: null,
            };
        case topUpActions.TOP_UP_FAIL:
            return {
                ...state,
                topUpErrorInfo: action.errorInfo,
                isTopUpModalVisible: true,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// /src/js/common/topUp/topUp.reducer.js